/**
 * F02 — Auto country + currency on first visit (IP-based).
 * Uses Shopify browsing_context_suggestions.json + /localization.
 * Runs once per session; skips if country already matches.
 */
(function () {
  const STORAGE_KEY = 'id_geo_localized';
  if (sessionStorage.getItem(STORAGE_KEY)) return;
  if (!window.Shopify || !window.Shopify.country) return;

  const root = window.Shopify.routes?.root || '/';
  const currentCountry = window.Shopify.country;
  const url =
    root +
    'browsing_context_suggestions.json?country[enabled]=true&currency[enabled]=true&country[exclude]=' +
    encodeURIComponent(currentCountry);

  fetch(url)
    .then(function (res) {
      return res.json();
    })
    .then(function (data) {
      var targetCountry = null;

      if (data.suggestions && data.suggestions.length > 0) {
        var parts = data.suggestions[0].parts;
        if (parts && parts.country && parts.country.handle) {
          targetCountry = parts.country.handle;
        }
      }

      if (!targetCountry && data.detected_values && data.detected_values.country) {
        targetCountry = data.detected_values.country.handle;
      }

      if (!targetCountry || targetCountry === currentCountry) return;

      sessionStorage.setItem(STORAGE_KEY, '1');

      var form = document.createElement('form');
      form.method = 'POST';
      form.action = root + 'localization';
      form.hidden = true;
      form.innerHTML =
        '<input name="_method" value="PUT" />' +
        '<input name="country_code" value="' + targetCountry + '" />' +
        '<input name="return_to" value="' + (window.location.pathname + window.location.search) + '" />';
      document.body.appendChild(form);
      form.submit();
    })
    .catch(function () {
      /* silent fail — header selector still works */
    });
})();
